<div class="dh-last-updated">
  <div class="last-updated">
    <span class="dh-text-label">{{'main_window.last_tree_refresh' | translate }}</span>
    <span [ngClass]="{'updated-now': isUpdatedByUser()}">{{getLastUpdate()}}</span>
  </div>
</div>
